import { useState } from "react";
import { BbotButton, BbotTag, SettingsCard } from "top-component-library";
import { CONFIG_TYPE_PRETTY_NAME } from "../constants";
import EnableWhiteLabelBuilderDialog from "./EnableWhiteLabelBuilderDialog";

// Mirrors edit-hostname-configs.html's "BOS Builder" card. Admin-only. The
// "document name goes here" line is leftover placeholder copy in production
// today - preserved verbatim rather than silently improved, since it's not
// this migration's call.
const BosBuilderCard = ({ hostnameConfig, bosBuilderUrl, onEnableWhiteLabelBuilder }) => {
  const { configType, hostname, canEdit } = hostnameConfig;
  const [showDialog, setShowDialog] = useState(false);

  return (
    <SettingsCard title="BOS Builder">
      <div>
        <p>
          (TOP by DoorDash Admin only) Allows you to create a configurable BOS from scratch for{" "}
          <strong>{hostname}</strong>.
        </p>
        {configType === "notConfigured" ? (
          <p>No configuration option has been chosen. Choose this configuration by pressing the enable button.</p>
        ) : configType === "bosBuilder" ? (
          <p>
            Guests will be shown current live document (document name goes here).{" "}
            <a href={bosBuilderUrl}>Edit the BOS for this hostname using the BOS Builder</a>.
          </p>
        ) : (
          <>
            <p>
              You can now create, edit, and publish the BOS for this hostname using the{" "}
              <a href={bosBuilderUrl}>BOS Builder</a>.
            </p>
            <p>
              <strong>
                <i>
                  Note: guests will still be shown the current configuration ({CONFIG_TYPE_PRETTY_NAME[configType]})
                  until you publish a draft on the BOS builder.
                </i>
              </strong>
            </p>
          </>
        )}
        {configType === "notConfigured" && (
          <BbotButton type="primary" onClick={() => setShowDialog(true)} disabled={!canEdit}>
            Enable
          </BbotButton>
        )}
        {(configType === "bosBuilder" || configType === "preBuilt") && (
          <div>
            <BbotTag color="green">Enabled</BbotTag>
            <BbotButton onClick={() => setShowDialog(true)} disabled={!canEdit}>
              Change Settings
            </BbotButton>
          </div>
        )}
      </div>
      <EnableWhiteLabelBuilderDialog
        visible={showDialog}
        hostnameConfig={hostnameConfig}
        onClose={() => setShowDialog(false)}
        onSave={onEnableWhiteLabelBuilder}
      />
    </SettingsCard>
  );
};

export default BosBuilderCard;
